import { Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import MetaFeatureCards from './MetaFeatureCards';
import MetaGetStarted from './MetaGetStarted';
import MetaHelpFooter from './MetaHelpFooter';
import MetaPrerequisites from './MetaPrerequisites';

function MetaOnboardingView(): JSX.Element {
  const theme = useMantineTheme();

  return (
    <Flex direction={'column'} gap={theme.spacing[4]}>
      <MetaFeatureCards />
      <MetaPrerequisites />
      <MetaGetStarted />
      <MetaHelpFooter />
    </Flex>
  );
}

export default MetaOnboardingView;
